import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { fetchRecordedPrices, addRecordedPrice } from "./RecordedPriceApi";

export function useRecordedPrices(storeId: string, itemId: string) {
    return useQuery(
        {
            queryKey: ['recordedPrices', storeId, itemId],
            queryFn: () => fetchRecordedPrices(storeId, itemId)
        }
    )
}


export function useAddRecordedPrice() {
    const queryClient = useQueryClient();
    return useMutation(
        {
            mutationFn: addRecordedPrice,
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: ['recordedPrices']
                })
            }
        }
    );
}